module.exports = __webpack_public_path__ + "static/media/triangle.bebd72c5.svg";